// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_MapItemListResultModel from '../../model/tdg-map-item-list-result-model';
import Tdg_MapItemListResultDTO from '../dto/tdg-map-item-list-result-dto';
import dtoSchema from '../schemas/tdg-map-item-list-result-schema';
import Tdg_MapItemModel from '../../model/tdg-map-item-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class Tdg_MapItemListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_MapItemListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Tdg_MapItemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: Tdg_MapItemModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<Tdg_MapItemListResultDTO>): Tdg_MapItemListResultModel;
  static toModel(dto: DeepPartial<Tdg_MapItemListResultDTO> | undefined | null): Tdg_MapItemListResultModel | undefined;
  static toModel(dto: DeepPartial<Tdg_MapItemListResultDTO> | undefined | null): Tdg_MapItemListResultModel | undefined {
    return dto ? new Tdg_MapItemListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_MapItemListResultModel> | Tdg_MapItemListResultModel): Tdg_MapItemListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as Tdg_MapItemListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_MapItemListResultModel, can not map to Tdg_MapItemListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
